import {
  RescheduleProposalItem,
  RescheduleProposalItemDto
} from './reschedule-proposals.models';

export function mapRescheduleProposalItem(
  dto: RescheduleProposalItemDto
): RescheduleProposalItem
{
  return {
    id: dto.id,
    appointmentId: dto.appointmentId,
    clientId: dto.clientId,
    clientEmail: dto.clientEmail,
    clientName: dto.clientName,
    oldPrimarySlotId: dto.oldPrimarySlotId,
    newPrimarySlotId: dto.newPrimarySlotId,
    oldPrimarySlot: dto.oldPrimarySlotStartTime && dto.oldPrimarySlotEndTime
      ? {
          id: dto.oldPrimarySlotId,
          startTime: dto.oldPrimarySlotStartTime,
          endTime: dto.oldPrimarySlotEndTime,
        }
      : undefined,
    newPrimarySlot: dto.newPrimarySlotStartTime && dto.newPrimarySlotEndTime
      ? {
          id: dto.newPrimarySlotId,
          startTime: dto.newPrimarySlotStartTime,
          endTime: dto.newPrimarySlotEndTime,
        }
      : undefined,
    oldSession: dto.oldSessionStartTime && dto.oldSessionEndTime
      ? {
          id: dto.oldPrimarySlotId,
          startTime: dto.oldSessionStartTime,
          endTime: dto.oldSessionEndTime,
        }
      : undefined,
    newSession: dto.newSessionStartTime && dto.newSessionEndTime
      ? {
          id: dto.newPrimarySlotId,
          startTime: dto.newSessionStartTime,
          endTime: dto.newSessionEndTime,
        }
      : undefined,
    reason: dto.reason ?? 'Reschedule required',
    status: dto.status,
    respondedByUserId: dto.respondedByUserId ?? null,
    respondedAt: dto.respondedAt ?? null,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt
  };
}
